module.exports = __webpack_public_path__ + "img/FeatureNotificationAllExampleCompressed.7974e130.png";